import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import { Page } from '../components/common'
import Header from '../components/Header'
import CardContainer from '../components/CardContainer'
import TrackCard from '../components/TrackCard'

const TrackList = ({ tracks }) => {
  return (
    <Page>
      <Helmet title='Walks' />
      <Header title='Walks' small />
      <CardContainer>
        {tracks &&
          tracks.map(track => <TrackCard track={track} key={track.sys.id} />)}
      </CardContainer>
    </Page>
  )
}

TrackList.propTypes = {
  tracks: PropTypes.array
}

export default TrackList



// WEBPACK FOOTER //
// ./src/views/TrackList.js